import { useMutation, useQueryClient } from "@tanstack/vue-query";
import baseAPI from "@/api/base";

export function useMarkNotificationSeen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ids: string[]) => {
      const response = await baseAPI.patch("/notification/seen", { ids });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
